import angular from 'angular';
import uiRouter from 'angular-ui-router';
import einzelticketComponent from './einzelticket.component';

let einzelticketModule = angular.module('einzelticket', [
  uiRouter
])

.component('einzelticket', einzelticketComponent)

.name;

export default einzelticketModule;



// WEBPACK FOOTER //
// ./client/app/common/forms/einzelticket/einzelticket.js